import React, {useCallback, useMemo, useState} from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {makeStyles} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import Grid from "@material-ui/core/Grid";
import VideocamIcon from '@material-ui/icons/Videocam';
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import Moment from "react-moment";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import useFieldSet from "./useFieldSet";

const useStyles = makeStyles(theme => ({
    buttons: {
        display: 'flex',
        justifyContent: 'space-between',
        paddingRight: theme.spacing(3),
        paddingLeft: theme.spacing(3),
        paddingBottom: theme.spacing(2),
    },
    table: {
        margin: 'auto',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        maxWidth: 500,
        '& .MuiTableCell-sizeSmall': {
            padding: 6,
        },
        '& .MuiTableCell-sizeSmall:last-of-type, & .MuiTableCell-sizeSmall:first-of-type': {
            width: '1%',
            whiteSpace: 'nowrap',
        },
    },
    miniIcon: {
        color: theme.palette.secondary.main,
        height: 18,
        marginBottom: -4,
    },
}));


export default function ValidateSessionDialog({component, onSave, selectedRecordings, canPedirPlantillas}) {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [pedirPlantillas, setPedirPlantillas] = useState(false);
    const [material, setMaterial] = useState('');
    const [quantities, setQuantities] = useState({azul: 0, sport: 0});
    const changeQuantity = (type, quantity) => setQuantities(previous => ({...previous, [type]: Math.max(0, Math.min(99, quantity))}));
    const totalPairs = quantities.azul + quantities.sport;
    const { values, setFieldValue, renderField } = useFieldSet({
    address: '',
    phone: '',
    email: '',
});
    const { t , i18n: { styleName } } = useTranslation();

    const handleClickOpen = () => {
    setPedirPlantillas(false);
    setMaterial('');
    setQuantities({azul: 0, sport: 0});
    setFieldValue({persist: () => {}, target: {name: 'address', value: ''}});
    setFieldValue({persist: () => {}, target: {name: 'phone', value: ''}});
    setFieldValue({persist: () => {}, target: {name: 'email', value: ''}}); 
    setOpen(true);
};

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            {React.cloneElement(component, {
                onClick: handleClickOpen,
            })}
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" fullScreen>
                <DialogTitle id="form-dialog-title">{t('ValidateSessionDialog.title')}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography>{t('ValidateSessionDialog.validar-grabaciones')}:</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Table className={classes.table} size="small" aria-label="sessions">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>{t('SessionBrowser.recordings-table.time')}</TableCell>
                                        <TableCell>{t('SessionBrowser.recordings-table.protocol')}</TableCell>
                                        <TableCell>{t('SessionBrowser.recordings-table.duration')}</TableCell>
                                        <TableCell />
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {selectedRecordings.map((row, i) => {
                                        let protocolName = '';

                                        if (row.protocolo)
                                            protocolName = row.protocolo.nombre
                                        else if (row.info && row.info.customName)
                                            protocolName = row.info.customName;
                                        else
                                            protocolName = 'Manual';

                                        if (row.info && (row.info.protocolId > 0 || row.info.customName) && row.info.isManual)
                                            protocolName = `${protocolName} (M)`;

                                        return (
                                            <TableRow key={row.fecha}>
                                                <TableCell><Moment format='HH:mm'>{row.fecha}</Moment></TableCell>
                                                <TableCell>
                                                    {protocolName}
                                                </TableCell>
                                                <TableCell>
                                                    {row.duracion !== null && <><VideocamIcon className={classes.miniIcon} /> {row.duracion}</>}
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </Grid>
                        {canPedirPlantillas ?
                            <>
                                <Grid item xs={12}>
                                    <Typography>{t('ValidateSessionDialog.consulta-validada-archivar')}.</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <div style={{display: 'flex', flexDirection: 'column', gap: '24px'}}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={pedirPlantillas}
                                                    onChange={ev => setPedirPlantillas(ev.target.checked)}
                                                    name="pedir-plantillas"
                                                    color="primary"
                                                />
                                            }
                                            label={t('ValidateSessionDialog.pedir-plantillas')}
                                        />
                                        {pedirPlantillas && styleName === 'footadapt' &&
                                        <FormControl component="fieldset" error={totalPairs === 0}>
                                            <FormLabel component="legend">{t('ValidateSessionDialog.material.label')}</FormLabel>
                                            {['azul', 'sport'].map(type => (
                                                <div key={type} style={{display: 'flex', alignItems: 'center', gap: 12, minHeight: 48}}>
                                                    <FormControlLabel
                                                        control={<Checkbox color="primary" checked={quantities[type] > 0}
                                                            onChange={event => changeQuantity(type, event.target.checked ? 1 : 0)} />}
                                                        label={t(`ValidateSessionDialog.material.${type}`)}
                                                        style={{minWidth: 180}}
                                                    />
                                                    {quantities[type] > 0 && <>
                                                        <IconButton size="small" aria-label="Decrease quantity" onClick={() => changeQuantity(type, quantities[type] - 1)}><RemoveIcon /></IconButton>
                                                        <Typography style={{minWidth: 22, textAlign: 'center'}}>{quantities[type]}</Typography>
                                                        <IconButton size="small" aria-label="Increase quantity" disabled={quantities[type] >= 99} onClick={() => changeQuantity(type, quantities[type] + 1)}><AddIcon /></IconButton>
                                                    </>}
                                                </div>
                                            ))}
                                           
                                             {totalPairs === 0 && <FormHelperText>{t('ValidateSessionDialog.material.error')}</FormHelperText>}
                                            </FormControl>}
                                            
                                            {pedirPlantillas && styleName !== 'footadapt' &&
                                                <FormControl component="fieldset" error={material === ''}>
                                                    <FormLabel component="legend">
                                                        {t('ValidateSessionDialog.material.label')}
                                                    </FormLabel>
                                                    <RadioGroup
                                                        aria-label="material"
                                                        name="material"
                                                        value={material}
                                                        onChange={ev => setMaterial(ev.target.value)}
                                                    >
                                                        <FormControlLabel
                                                            value="azul"
                                                            control={<Radio />}
                                                            label="Dark Blue"
                                                        />
                                                        <FormControlLabel
                                                            value="sport"
                                                            control={<Radio />}
                                                            label="Sport Blue"
                                                        />
                                                    </RadioGroup>
                                                    {material === '' &&
                                                        <FormHelperText>
                                                            {t('ValidateSessionDialog.material.error')}
                                                        </FormHelperText>
                                                    }
                                                </FormControl>
                                            }
                                            </div>
                                            </Grid>
                                             {pedirPlantillas && styleName !== 'footadapt' &&
                                                <Grid item xs={6}>
                                                    {renderField('address', t('ValidateSessionDialog.input-address'), {error: values.address === ''})}
                                                    {renderField('phone', t('ValidateSessionDialog.input-phone'), {error: values.phone === ''})}
                                                    {renderField('email', t('ValidateSessionDialog.input-email'), {error: values.email === ''})}
                                                </Grid>
                                            }


                                            </>
                                            :
                                       
                            <Grid item xs={12}>
                                <Typography>{t('ValidateSessionDialog.consulta-validada-apli')}.</Typography>
                            </Grid>
                        }
                    </Grid>
                </DialogContent>
                <DialogActions className={classes.buttons}>
                    <Button onClick={handleClose} color="primary">
                        {t('ValidateSessionDialog.cancel')}
                    </Button>
                    <Button
                        onClick={() => {
                            onSave({
                                selectedRecordings,
                                pedirPlantillas,
                                material: styleName === 'footadapt'
                                    ? (quantities.azul > 0 && quantities.sport === 0
                                        ? 'azul'
                                        : quantities.sport > 0 && quantities.azul === 0
                                            ? 'sport'
                                            : '')
                                    : material,
                                quantities: styleName === 'footadapt'
                                    ? quantities
                                    : undefined,
                                ...(styleName !== 'footadapt' ? values : {}),
                            });
                            handleClose();
                        }}
                        color="primary"
                        variant="contained"
                        disabled={pedirPlantillas && (styleName === 'footadapt' ? totalPairs === 0 : material === '' || Object.values(values).some(v => v === ''))}
                    >
                        {t('ValidateSessionDialog.ok')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
